import {
  Button,
  Chip,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
  withStyles,
  Container,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton
} from '@material-ui/core';
import {
  Add,
  Delete as DeleteIcon,
  Info as InfoIcon,
  Close as CloseIcon,
  Save as SaveIcon,
  ArrowBack as ArrowBackIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Delete
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import MuiAlert, { AlertProps, type Color } from '@material-ui/lab/Alert';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@services/api';
import { estados } from '@data/estados';
import { planos } from '@data/planos';
import { maskCharSpecial } from '@utils/masks';
import { AppError } from '@utils/AppError';

interface IExames {
  id_exames: string;
  nome: string;
}

interface IRiscos {
  id_risco: string;
  nome: string;
}

interface ICnpj {
  bairro: string;
  cep: string;
  cidade: string;
  cnae: string;
  cnae_secundario: string;
  complemento: string;
  estado: string;
  idcad_empresa: number;
  inf_contrato: string;
  nome_empresa: string;
  nome_fantacia: string;
  num_cnpj: string;
  numero: number | null;
  razao_social: string;
  rua: string;
}

interface LocalObra {
  cod_local: string;
  cnpj_local: string;
  nome: string;
  razao_social: string;
  data_inicio: string;
  data_fim: string;
  num_cnpj: string;
  rua: string;
  numero: string;
  cep: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
}

interface IExamesToxico {
  id_exame_tox: string;
  nome: string;
}

const ButtonAdd = withStyles(() => ({
  root: {
    background: '#0D9C5B',
    color: '#FFF',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 500,
    padding: '8px 16px',
    textTransform: 'none',
    '&:hover': {
      background: '#FFF',
      borderColor: '#0D9C5B',
      color: '#0D9C5B',
      border: 'solid 1px #0D9C5B'
    }
  }
}))(Button);

export const Cadastroghi = () => {
  const [selectLocalObra, setSelectLocalObra] = useState<LocalObra[]>([]);
  const [selectedLocalObra, setSelectedLocalObra] = useState<LocalObra | null>(null);
  const [codGhe, setCodGhe] = useState('');
  const [nomeGhe, setNomeGhe] = useState('');
  const [nomeMedico, setNomeMedico] = useState('');
  const [crm, setCrm] = useState<string>('');
  const [estadoCrm, setEstadoCrm] = useState<string>('');
  const [snack, setSnack] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [cod, setCod] = useState('');
  const [severity, setSeverity] = useState<Color>();
  const [contratos, setContratos] = useState<ICnpj[]>([]);
  const [obsASO, setObsASO] = useState<string>('');
  const [risco, setRisco] = useState<IRiscos[]>([]);
  const [listRisco, setListRisco] = useState<IRiscos[]>([]);
  const [newData, setNewData] = useState<IExames[]>([]);
  const [valor, setValor] = useState<number | null>(null);
  const [novoValor, setNovoValor] = useState<any[]>([]);
  const [campoValor, setCampoValor] = useState<any[]>([]);
  const [dialog, setDialog] = useState<boolean>(false);
  const [dialogDelete, setDialogDelete] = useState(false);
  const [singleExame, setSingleExame] = useState<IExames | null>(null);
  const [valorTotal, setValorTotal] = useState<number>(0);
  const [plano, setPlano] = useState<string>('');
  const [valorPlano, setValorPlano] = useState<string>('');
  const [asoCheck, setAsoCheck] = useState({
    admissional: false,
    demissional: false,
    periodico: false,
    mudancaDeRiscos: false,
    retornoAoTrabalho: false,
    monitoramento: false
  });
  const [valorToxico, setValorToxico] = useState<number | null>(null);
  const [novoValorToxico, setNovoValorToxico] = useState<any[]>([]);
  const [campoValorToxico, setCampoValorToxico] = useState<any[]>([]);
  const [dialogToxico, setDialogToxico] = useState<boolean>(false);
  const [dialogDeleteToxico, setDialogDeleteToxico] = useState(false);
  const [singleExameToxico, setSingleExameToxico] = useState<IExamesToxico | null>(null);
  const [valorTotalToxico, setValorTotalToxico] = useState<number>(0);
  const [newDataToxico, setNewDataToxico] = useState<IExamesToxico[]>([]);
  const [tagGhe, setTagGhe] = useState('');
  
  // Estados para controle de erros
  const [errors, setErrors] = useState({
    localObra: false,
    codGhe: false,
    nomeGhe: false,
    nomeMedico: false,
    crm: false,
    estadoCrm: false,
    plano: false,
    exames: false
  });

  useEffect(() => {
    const fetchDataSequentially = async () => {
      try {
        const examesRes = await api.get('/ravim/exames');
        setNewData(examesRes.data);

        const riscosRes = await api.get('ravim/riscos');
        setListRisco(riscosRes.data);

        const locaisRes = await api.get('ravim/localObra');
        setSelectLocalObra(locaisRes.data);

        const toxicologicoRes = await api.get('ravim/exame-tox');
        setNewDataToxico(toxicologicoRes.data);

        const contratosRes = await api.get('ravim/empresas-rh');
        setContratos(contratosRes.data);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        setSnack(true);
        setSeverity('error');
        setMessage('Erro ao carregar dados do servidor');
      }
    };

    fetchDataSequentially();
  }, []);

  // Função de validação do formulário
  const validateForm = () => {
    const newErrors = {
      localObra: !selectedLocalObra,
      codGhe: !codGhe.trim(),
      nomeGhe: !nomeGhe.trim(),
      nomeMedico: !nomeMedico.trim(),
      crm: !crm.trim(),
      estadoCrm: !estadoCrm.trim(),
      plano: !plano.trim(),
      exames: campoValor.length === 0 && campoValorToxico.length === 0
    };
    
    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error);
  };

  async function sendGHE() {
    if (!validateForm()) {
      setSnack(true);
      setSeverity('error');
      setMessage('Preencha todos os campos obrigatórios');
      return;
    }

    const data = {
      cod_obra: selectedLocalObra?.cod_local,
      cod_ghe: tagGhe
        ? `${codGhe}-${tagGhe
            .replace(/(\s{1})/g, '-$1')
            .replace(/\s/g, '')}`.trim()
        : codGhe.trim(),
      nome_ghe: nomeGhe.trim(),
      exames_ghe: campoValor,
      risco_ghe: risco,
      obs_aso: obsASO,
      nome_medico: nomeMedico.trim(),
      crm,
      crm_estado: estadoCrm,
      tipo_plano: plano,
      valor_plano: valorPlano,
      toxicologico: campoValorToxico
    };

    try {
      const res = await api.post('ravim/cad-ghe', data);
      setCod(String(res.status));
      setSnack(true);
      setSeverity('success');
      setMessage(res.data.message);
      setTimeout(() => {
        window.location.replace('/ghe');
      }, 3000);
    } catch (err) {
      if (err instanceof AppError) {
        setCod(String(err.code));
        setSnack(true);
        setSeverity('error');
        setMessage(err.message);
      }
    }
  }

  function closeDialog() {
    setDialog(false);
    setDialogDelete(false);
  }

  function saveNewValor() {
    setNovoValor([...campoValor]);
    setDialog(false);
  }

  function deleteExame(id: string) {
    const newList = campoValor.filter((exame: any) => exame.id_exames !== id);
    const verifyValues = newList.map((v: any) =>
      isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias)
    );
    const sub = verifyValues.reduce(
      (soma: number, i: number) => soma - i * -1,
      0
    );

    setValorTotal(sub);
    setCampoValor(newList);
  }

  function valueExames() {
    if (!singleExame) {
      alert('Selecione um exame');
      return;
    }

    const newVar = [...campoValor];
    const data = {
      id_exames: singleExame.id_exames,
      nome: singleExame.nome,
      dias: valor === null ? '0' : valor,
      ...Object.fromEntries(
        Object.entries(asoCheck)
          .filter(([_, value]) => value)
          .map(([key]) => [key, key])
      )
    };

    newVar.push(data);
    setCampoValor(newVar);

    const verifyValues = newVar.map((v: any) =>
      isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias)
    );
    setValorTotal(verifyValues.reduce((soma, i) => soma + i, 0));

    setSingleExame(null);
    setValor(null);
    setAsoCheck({
      admissional: false,
      demissional: false,
      periodico: false,
      mudancaDeRiscos: false,
      retornoAoTrabalho: false,
      monitoramento: false
    });
  }

  // Funções para exames toxicológicos (similares às dos exames comuns)
  function closeDialogToxico() {
    setDialogToxico(false);
    setDialogDeleteToxico(false);
  }

  function saveNewValorToxico() {
    setNovoValorToxico([...campoValorToxico]);
    setDialogToxico(false);
  }

  function deleteExameToxico(id: string) {
    const newList = campoValorToxico.filter(
      (exame: any) => exame.id_exames !== id
    );
    const verifyValues = newList.map((v: any) => {
      return isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias);
    });
    const sub = verifyValues.reduce(
      (soma: number, i: number) => soma - i * -1,
      0
    );

    setValorTotalToxico(sub);
    setCampoValorToxico(newList);
  }

  function valueExamesToxico() {
    if (singleExameToxico === null) {
      alert('Selecione um exame');
    } else {
      const newVar = [...campoValorToxico];
      const data = {
        id_exames: singleExameToxico?.id_exame_tox,
        nome: singleExameToxico?.nome,
        dias: valorToxico === null ? '0' : valorToxico,
        admissional: asoCheck.admissional ? 'admissional' : '',
        demissional: asoCheck.demissional ? 'demissional' : '',
        periodico: asoCheck.periodico ? 'periodico' : '',
        mudanca_de_riscos: asoCheck.mudancaDeRiscos ? 'mudanca_de_riscos' : '',
        retorno_ao_trabalho: asoCheck.retornoAoTrabalho
          ? 'retorno_ao_trabalho'
          : '',
        monitoramento: asoCheck.monitoramento ? 'monitoramento' : ''
      };
      newVar.push(data);
      setCampoValorToxico(newVar);

      const verifyValues = newVar.map((v: any) => {
        return isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias);
      });
      const soma = verifyValues.reduce((soma, i) => {
        return soma + i;
      });
      setValorTotalToxico(soma);

      setSingleExameToxico(null);
      setValorToxico(null);
      setAsoCheck({
        admissional: false,
        demissional: false,
        periodico: false,
        mudancaDeRiscos: false,
        retornoAoTrabalho: false,
        monitoramento: false
      });
    }
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAsoCheck({ ...asoCheck, [event.target.name]: event.target.checked });
  };

  const isFormValid = () => {
    return (
      selectedLocalObra !== null &&
      codGhe.trim() !== '' &&
      nomeGhe.trim() !== '' &&
      nomeMedico.trim() !== '' &&
      crm.trim() !== '' &&
      estadoCrm.trim() !== '' &&
      // plano.trim() !== '' &&
      (campoValor.length > 0 )
    );
  };

  return (
    <Container
      maxWidth="lg"
      style={{
        padding: '24px 0',
        backgroundColor: '#f9f9f9',
        minHeight: '100vh'
      }}
    >
      <Paper
        elevation={3}
        style={{
          padding: '32px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      >
        <Typography
          variant="h4"
          align="center"
          style={{
            marginBottom: '32px',
            fontWeight: 600,
            color: '#2c3e50',
            position: 'relative',
            paddingBottom: '16px'
          }}
        >
          Cadastrar GHE
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: '#0D9C5B',
              borderRadius: '2px'
            }}
          />
        </Typography>

        {/* Seção Informações do GHE */}
        <div
          style={{
            marginBottom: '32px',
            padding: '16px',
            borderLeft: '4px solid #0D9C5B',
            backgroundColor: '#f0f7f4'
          }}
        >
          <Typography
            variant="h6"
            style={{
              marginBottom: '16px',
              fontWeight: 600,
              color: '#2c3e50',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <InfoIcon color="primary" />
            Informações do GHE
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={selectLocalObra}
                getOptionLabel={(option: LocalObra) =>
                  `${option.cnpj_local} - ${option.cod_local} - ${option.nome}`
                }
                onChange={(e, newValue: LocalObra | null) => {
                  setSelectedLocalObra(newValue);
                  setCodGhe(newValue?.cod_local || '');
                  if (newValue?.cod_local !== codGhe) {
                    setTagGhe('');
                  }
                }}
                value={selectedLocalObra}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Locais/Obras Cadastrados"
                    placeholder="Selecione um local/obra"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: '8px', backgroundColor: '#fff' }
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                label="Código GHE"
                disabled
                value={
                  tagGhe
                    ? `${codGhe}-${tagGhe
                        .replace(/(\s{1})/g, '-$1')
                        .replace(/\s/g, '')}`
                    : codGhe
                }
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#f5f5f5' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                label="Tag GHE"
                value={tagGhe}
                disabled={!codGhe}
                onChange={(e) => setTagGhe(maskCharSpecial(e.target.value))}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Nome GHE"
                value={nomeGhe}
                onChange={(e) => setNomeGhe(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Médico responsável"
                value={nomeMedico}
                onChange={(e) => setNomeMedico(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                variant="outlined"
                label="CRM"
                value={crm}
                onChange={(e) => setCrm(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  label="Estado"
                  value={estadoCrm}
                  onChange={(e: any) => setEstadoCrm(e.target.value)}
                  style={{ borderRadius: '8px', backgroundColor: '#fff' }}
                >
                  {estados.map((estado, index) => (
                    <MenuItem key={index} value={estado.estado}>
                      {estado.estado}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                label="Observação ASO"
                value={obsASO}
                onChange={(e) => setObsASO(e.target.value)}
                minRows={4}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Plano</InputLabel>
                <Select
                  label="Plano"
                  value={plano}
                  onChange={(e: any) => setPlano(e.target.value)}
                  style={{ borderRadius: '8px', backgroundColor: '#fff' }}
                >
                  {planos.map((plano, index) => (
                    <MenuItem key={index} value={plano.value}>
                      {plano.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>

        {/* Seção Exames */}
        <div
          style={{
            marginBottom: '32px',
            padding: '16px',
            borderLeft: '4px solid #2196F3',
            backgroundColor: '#f0f7ff'
          }}
        >
          <Typography
            variant="h6"
            style={{
              marginBottom: '16px',
              fontWeight: 600,
              color: '#2c3e50',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <InfoIcon color="primary" />
            Exames e Riscos
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ButtonAdd
                fullWidth
                variant="contained"
                startIcon={<Add />}
                onClick={() => setDialog(true)}
                style={{ height: '56px' }}
              >
                Adicionar Exames
              </ButtonAdd>

              <Dialog
                open={dialog}
                onClose={closeDialog}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderBottom: '1px solid #e0e0e0'
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    Adicionar Exames
                  </Typography>
                </DialogTitle>
                <DialogContent style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px'
                      }}
                    >
                      <Autocomplete
                        style={{ flex: 1 }}
                        onKeyDown={(e: any) => {
                          if (e.key === 'Enter') valueExames();
                        }}
                        id="tags-outlined"
                        options={newData}
                        getOptionLabel={(option: IExames) =>
                          `${option.id_exames} - ${option.nome}`
                        }
                        onChange={(e, newValue: any) =>
                          setSingleExame(newValue)
                        }
                        value={singleExame}
                        getOptionDisabled={(option) => {
                          const valueDisbled = campoValor.map(
                            (exame: any) => exame
                          );
                          return !!valueDisbled.find(
                            (element) => element.nome === option.nome
                          );
                        }}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Selecione o exame"
                            placeholder="Digite para buscar..."
                            size="small"
                          />
                        )}
                      />

                      <TextField
                        onKeyDown={(e: any) => {
                          if (e.key === 'Enter') valueExames();
                        }}
                        type="number"
                        label="Dias"
                        variant="outlined"
                        value={valor || ''}
                        onChange={(e: any) => setValor(e.target.value)}
                        disabled={!asoCheck.periodico}
                        style={{ width: '120px' }}
                        size="small"
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={valueExames}
                        startIcon={<Add />}
                        style={{ height: '40px' }}
                      >
                        Adicionar
                      </Button>
                    </div>

                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        marginBottom: '16px',
                        backgroundColor: '#fafafa'
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          marginBottom: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Tipos de ASO
                      </Typography>

                      <FormGroup row style={{ gap: '16px' }}>
                        {Object.entries(asoCheck).map(([key, value]) => (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={value}
                                onChange={handleCheck}
                                name={key}
                                color="primary"
                              />
                            }
                            label={
                              <Typography
                                style={{ textTransform: 'capitalize' }}
                              >
                                {key.replace(/([A-Z])/g, ' $1').trim()}
                              </Typography>
                            }
                          />
                        ))}
                      </FormGroup>
                    </Paper>
                  </div>

                  {campoValor.length > 0 && (
                    <div style={{ marginBottom: '20px' }}>
                      <Typography
                        variant="subtitle1"
                        style={{
                          marginBottom: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Exames Adicionados
                      </Typography>

                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns:
                            'repeat(auto-fill, minmax(300px, 1fr))',
                          gap: '12px'
                        }}
                      >
                        {campoValor.map((valores: any, i) => (
                          <Paper
                            key={i}
                            elevation={2}
                            style={{ padding: '12px' }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '8px'
                              }}
                            >
                              <div>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  ID: {valores.id_exames}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  style={{ fontWeight: '500' }}
                                >
                                  {valores.nome}
                                </Typography>
                              </div>

                              <IconButton
                                onClick={() => deleteExame(valores.id_exames)}
                                size="small"
                                style={{ color: '#f44336' }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </div>

                            <div style={{ display: 'flex', gap: '8px' }}>
                              <Chip
                                label={`${valores.dias || 0} Dias`}
                                size="small"
                                variant="outlined"
                              />

                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '4px'
                                }}
                              >
                                {Object.entries(valores)
                                  .filter(
                                    ([key, value]) =>
                                      key !== 'id_exames' &&
                                      key !== 'nome' &&
                                      key !== 'dias' &&
                                      value
                                  )
                                  .map(([key, value], idx) => (
                                    <Chip
                                      key={idx}
                                      label={key.replace(/_/g, ' ')}
                                      size="small"
                                      color="primary"
                                    />
                                  ))}
                              </div>
                            </div>
                          </Paper>
                        ))}
                      </div>
                    </div>
                  )}

                  {campoValor.length > 0 && (
                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        backgroundColor: '#f5f5f5',
                        marginTop: '16px'
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{ textAlign: 'center' }}
                      >
                        <strong>Total de exames:</strong> {campoValor.length} |
                        <strong> Total de dias:</strong> {valorTotal}
                      </Typography>
                    </Paper>
                  )}
                </DialogContent>

                <DialogActions
                  style={{
                    padding: '16px 24px',
                    borderTop: '1px solid #e0e0e0'
                  }}
                >
                  <Button onClick={closeDialog} style={{ marginRight: '8px' }}>
                    Cancelar
                  </Button>
                  <Button
                    onClick={saveNewValor}
                    variant="contained"
                    color="primary"
                    disabled={campoValor.length === 0}
                  >
                    Salvar
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Grid item xs={12} md={6}>
              <ButtonAdd
                fullWidth
                variant="contained"
                startIcon={<Add />}
                onClick={() => setDialogToxico(true)}
                style={{ height: '56px' }}
              >
                Adicionar Exames Toxicológicos
              </ButtonAdd>

              <Dialog
                open={dialogToxico}
                onClose={closeDialogToxico}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderBottom: '1px solid #e0e0e0'
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    Adicionar Exames Toxicológicos
                  </Typography>
                </DialogTitle>

                <DialogContent style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px'
                      }}
                    >
                      <Autocomplete
                        style={{ flex: 1 }}
                        options={newDataToxico}
                        getOptionLabel={(option: IExamesToxico) =>
                          `${option.id_exame_tox} - ${option.nome}`
                        }
                        onChange={(event, newValue: IExamesToxico | null) => {
                          setSingleExameToxico(newValue);
                        }}
                        value={singleExameToxico}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Selecione o exame toxicológico"
                            placeholder="Digite para buscar..."
                            size="small"
                          />
                        )}
                      />

                      <TextField
                        type="number"
                        label="Dias"
                        variant="outlined"
                        value={valorToxico || ''}
                        onChange={(e) => setValorToxico(Number(e.target.value))}
                        disabled={!asoCheck.periodico}
                        style={{ width: '120px' }}
                        size="small"
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={valueExamesToxico}
                        startIcon={<Add />}
                        style={{ height: '40px' }}
                      >
                        Adicionar
                      </Button>
                    </div>

                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        marginBottom: '16px',
                        backgroundColor: '#fafafa'
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          marginBottom: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Tipos de ASO
                      </Typography>

                      <FormGroup row style={{ gap: '16px' }}>
                        {Object.entries(asoCheck).map(([key, value]) => (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={value}
                                onChange={handleCheck}
                                name={key}
                                color="primary"
                              />
                            }
                            label={
                              <Typography
                                style={{ textTransform: 'capitalize' }}
                              >
                                {key.replace(/([A-Z])/g, ' $1').trim()}
                              </Typography>
                            }
                          />
                        ))}
                      </FormGroup>
                    </Paper>
                  </div>

                  {campoValorToxico.length > 0 && (
                    <>
                      <Typography
                        variant="subtitle1"
                        style={{
                          marginBottom: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Exames Toxicológicos Adicionados
                      </Typography>

                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns:
                            'repeat(auto-fill, minmax(300px, 1fr))',
                          gap: '12px',
                          marginBottom: '16px'
                        }}
                      >
                        {campoValorToxico.map((valores: any, i) => (
                          <Paper
                            key={i}
                            elevation={2}
                            style={{ padding: '12px' }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '8px'
                              }}
                            >
                              <div>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  ID:{' '}
                                  {valores.id_exame_tox || valores.id_exames}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  style={{ fontWeight: '500' }}
                                >
                                  {valores.nome}
                                </Typography>
                              </div>

                              <IconButton
                                onClick={() =>
                                  deleteExameToxico(
                                    valores.id_exame_tox || valores.id_exames
                                  )
                                }
                                size="small"
                                style={{ color: '#f44336' }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center'
                              }}
                            >
                              <Chip
                                label={`${valores.dias || 0} Dias`}
                                size="small"
                                style={{
                                  backgroundColor: '#e3f2fd',
                                  color: '#1976d2'
                                }}
                              />

                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '4px'
                                }}
                              >
                                {Object.entries(valores)
                                  .filter(
                                    ([key, value]) =>
                                      ![
                                        'id_exame_tox',
                                        'id_exames',
                                        'nome',
                                        'dias'
                                      ].includes(key) && value
                                  )
                                  .map(([key], idx) => (
                                    <Chip
                                      key={idx}
                                      label={key.replace(/_/g, ' ')}
                                      size="small"
                                      style={{
                                        backgroundColor: '#e8f5e9',
                                        color: '#2e7d32'
                                      }}
                                    />
                                  ))}
                              </div>
                            </div>
                          </Paper>
                        ))}
                      </div>

                      <Paper
                        elevation={0}
                        style={{
                          padding: '16px',
                          backgroundColor: '#f5f5f5'
                        }}
                      >
                        <Typography
                          variant="body1"
                          style={{ textAlign: 'center' }}
                        >
                          <strong>Total de exames:</strong>{' '}
                          {campoValorToxico.length} |
                          <strong> Total de dias:</strong> {valorTotalToxico}
                        </Typography>
                      </Paper>
                    </>
                  )}
                </DialogContent>

                <DialogActions
                  style={{
                    padding: '16px 24px',
                    borderTop: '1px solid #e0e0e0'
                  }}
                >
                  <Button
                    onClick={closeDialogToxico}
                    style={{ marginRight: '8px' }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={saveNewValorToxico}
                    variant="contained"
                    color="primary"
                    disabled={campoValorToxico.length === 0}
                  >
                    Salvar
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={listRisco}
                getOptionLabel={(option: IRiscos) =>
                  `${option.id_risco} - ${option.nome}`
                }
                onChange={(e, newValue: IRiscos[]) => setRisco(newValue)}
                value={risco}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Riscos Ocupacionais"
                    placeholder="Selecione os riscos"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: '8px', backgroundColor: '#fff' }
                    }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id_risco}
                      label={`${option.id_risco} - ${option.nome}`}
                      style={{
                        margin: '4px',
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2'
                      }}
                    />
                  ))
                }
              />
            </Grid>
          </Grid>
        </div>

        {/* Botões de Ação */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '16px',
            marginTop: '32px',
            paddingTop: '16px',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            style={{
              color: '#5f6c7b',
              borderColor: '#e0e0e0',
              padding: '8px 24px',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500
            }}
            component={Link}
            to="/ghe"
          >
            Voltar
          </Button>

          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={sendGHE}
            disabled={!isFormValid()} // Aqui usamos a função de validação
            style={{
              backgroundColor: isFormValid() ? '#0D9C5B' : '#cccccc',
              color: '#fff',
              padding: '8px 24px',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              boxShadow: 'none'
            }}
          >
            Salvar GHE
          </Button>
        </div>
      </Paper>

      <Snackbar
        open={snack}
        autoHideDuration={3000}
        onClose={() => setSnack(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ marginTop: '64px' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={severity}
          onClose={() => setSnack(false)}
          style={{
            borderRadius: '8px',
            alignItems: 'center',
            fontWeight: 500
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {severity === 'success' ? (
              <CheckCircleIcon style={{ marginRight: '8px' }} />
            ) : (
              <ErrorIcon style={{ marginRight: '8px' }} />
            )}
            {`${cod} - ${message}`}
          </div>
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};
